import React, { useEffect } from "react";
import SupportTicketFileInfo from "./supportTicketFileInfo";
import { useParams } from "react-router-dom";
import useSupportStore from "../../stores/chatStore";
import { useTranslation } from "react-i18next";
import OrdersService from "../../api/orderHistoryService";
import OrderStatus from "../common/orderStatus/orderStatus";
import { ORDER_STATUS } from "../common/orderStatus/status.constants";

const SupportTicketRightPart: React.FC = () => {
  const { t } = useTranslation();

  const { ticket } = useParams<{ ticket: string }>();
  const { fileInfo, fetchFileInfo } = useSupportStore();
  const ordersService = new OrdersService();

  useEffect(() => {
    fetchFileInfo(Number(ticket));
  }, []);

  function downloadFile(id: any): void {
    ordersService.downloadFile(id);
  }

  function downloadEcuFile(id: any): void {
    ordersService.downloadEcuFile(id);
  }

  return (
    <>
      <p className="text-xl">{t("File info")}</p>

      <SupportTicketFileInfo />

      <p className="mt-5 text-xl">Option</p>

      <div className="mt-4 p-5 border rounded-xl border-tableline flex">
        <div className="flex flex-wrap">
          {fileInfo?.options !== undefined ? (
            fileInfo.options.map((option: any, subindex: number) => (
              <p
                key={subindex}
                className="py-1 px-2 m-1 text-primary bg-primary bg-opacity-30 rounded-xl"
              >
                {option}
              </p>
            ))
          ) : (
            <>
              <div className="py-1 px-2 m-1 rounded-xl bg-gray-200 dark:bg-gray-700 animate-pulse h-8 w-20"></div>
              <div className="py-1 px-2 m-1 rounded-xl bg-gray-200 dark:bg-gray-700 animate-pulse h-8 w-16"></div>
              <div className="py-1 px-2 m-1 rounded-xl bg-gray-200 dark:bg-gray-700 animate-pulse h-8 w-24"></div>
            </>
          )}
        </div>
      </div>

      <div className="mt-6 space-y-4">
        {fileInfo !== null ? (
          <>
            <OrderStatus status={fileInfo.status} />

            {fileInfo.waitMinutes && (
              <span>
                {t("Estimated waiting time:")}
                {` ${Math.floor(fileInfo.waitMinutes / 60)} ${t("h.")} ${
                  fileInfo.waitMinutes % 60
                } ${t("m.")}`}
              </span>
            )}

            {(fileInfo.status === ORDER_STATUS.COMPLETED ||
              fileInfo.status === ORDER_STATUS.COMPLETEDMANUALLY ||
              fileInfo.status === ORDER_STATUS.PROCESSED ||
              fileInfo.status === ORDER_STATUS.PROCESSED_ALT) && (
              <button
                className="border border-primary rounded-md md:w-1/2 max-md:w-full h-11 items-center 
          justify-center hover:bg-primary transition duration-300 ease-in-out"
                onClick={() => downloadFile(fileInfo?.id)}
              >
                {t("Download")}
              </button>
            )}

            {fileInfo.isTwoEcu &&
              (fileInfo.status === ORDER_STATUS.COMPLETED ||
                fileInfo.status === ORDER_STATUS.COMPLETEDMANUALLY ||
                fileInfo.status === ORDER_STATUS.PROCESSED ||
                fileInfo.status === ORDER_STATUS.PROCESSED_ALT) && (
                <button
                  className="border border-primary rounded-md md:w-1/2 max-md:w-full h-11 items-center 
          justify-center hover:bg-primary transition duration-300 ease-in-out"
                  onClick={() => downloadEcuFile(fileInfo?.id)}
                >
                  {t("Download Ecu2")}
                </button>
              )}
          </>
        ) : (
          // Упрощенные скелетоны
          <div className="space-y-4">
            <div className="h-4 w-3/4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
            <div className="h-11 w-1/2 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default SupportTicketRightPart;
